import { 
    ISSUES_SUMMARY_API_REQUEST,
    SAVE_ISSUES_SUMMARY_RESPONSE,
    USER_NAVIGATE_FROM_NHC
} from "../../constants/graphConstants/connectedClientsGraphConstants";
  
export const aprecomIssuesSummaryReducer = (
  state = {  issuesSummary: {
    clientMap : [],
    routerMap : [], 
    siteMap : [],
    userNavigate : null
  } },
  action
) => {
  switch (action.type) {
    case ISSUES_SUMMARY_API_REQUEST:
      return {
          ...state,
          issuesSummary: {
            loading: action.payload,
          } 
      };
    case SAVE_ISSUES_SUMMARY_RESPONSE:
      return {
        ...state,
        issuesSummary: {
            loading: false,
            ...action.payload
          } 
      };
    case USER_NAVIGATE_FROM_NHC:
      return {
        ...state,
        issuesSummary: {
            ...state.issuesSummary,
            userNavigate : action.payload
          } 
      };
    default:
      return state;
    }
}